<!-- Header -->
<div mat-dialog-title
    style="text-align: center;"
    class="errorRed">
    <span translate>WARNING</span>
</div>

<!-- Body -->
<mat-dialog-content>
    <div class="errorRed">
        <span translate>The</span>
        {{field.DisplayName}}
        <span translate>field is needed to relate other fields to this query.</span>
    </div>
    <div translate>If you continue, the following fields will be removed.</div>
    <div>
        <ul>
            <li *ngFor="let clusterField of removedFields">
                <data-query-field-label [field]="clusterField"></data-query-field-label>
            </li>
        </ul>
    </div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

    <!-- Left -->
    <div class="flex-footer-left"></div>

    <!-- Right -->
    <div class="flex-footer-right">

        <!-- Continue -->
        <tyl-button image="next arrow.png"
            label="Continue"
            (clickEvent)="continue()"></tyl-button>

        <!-- Cancel -->
        <tyl-button image="Cancel.png"
            label="Cancel"
            (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>